import { render } from "./toggle.vue?vue&type=template&id=5c2a4762"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"
import "./toggle.vue?vue&type=style&index=1&id=5c2a4762&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__